//NOTE - env api
export const NG_APP_API_ENDPOINT = import.meta.env.NG_APP_API_ENDPOINT;
export const NG_APP_ENV = import.meta.env.NG_APP_ENV;
export const NG_APP_S3_PUB_BULB_URL = import.meta.env.NG_APP_S3_PUB_BULB_URL;
export const NG_APP_WEB_ECOUPON_NITTO_URL = import.meta.env.NG_APP_WEB_ECOUPON_NITTO_URL;
export const NG_APP_WEB_ECOUPON_TOYO_URL = import.meta.env.NG_APP_WEB_ECOUPON_TOYO_URL;
export const NG_APP_WEB_GRIP_URL = import.meta.env.NG_APP_WEB_GRIP_URL;
export const NG_APP_WEB_NANKANG_URL = import.meta.env.NG_APP_WEB_NANKANG_URL;
export const NG_APP_WEB_NITTO_URL = import.meta.env.NG_APP_WEB_NITTO_URL;
export const NG_APP_WEB_TOYO_URL = import.meta.env.NG_APP_WEB_TOYO_URL;
export const NG_APP_WEB_ADVANCE_URL = import.meta.env.NG_APP_WEB_ADVANCE_URL;
export const NG_APP_WEB_WARRANTY_GRIP_URL = import.meta.env.NG_APP_WEB_WARRANTY_GRIP_URL;
export const NG_APP_WEB_WARRANTY_NANKANG_URL = import.meta.env.NG_APP_WEB_WARRANTY_NANKANG_URL;
export const NG_APP_WEB_WARRANTY_NITTO_URL = import.meta.env.NG_APP_WEB_WARRANTY_NITTO_URL;
export const NG_APP_WEB_WARRANTY_TOYO_URL = import.meta.env.NG_APP_WEB_WARRANTY_TOYO_URL;
export const NG_APP_WEB_WARRANTY_ADVANCE_URL = import.meta.env.NG_APP_WEB_WARRANTY_ADVANCE_URL;
export const NG_APP_WEB_VERIFY_WARRANTY_URL = import.meta.env.NG_APP_WEB_VERIFY_WARRANTY_URL;
